<template>
  <v-card>
    <v-card-text>
      <v-btn
        fab
        small
        color="green"
        class="ma-2 white--text"
        @click.stop="detailsUser($route.params.animateur)"
      >
        <v-icon dark>
          mdi-arrow-left-circle
        </v-icon>
      </v-btn>
      <v-btn color="blue-grey" class="ma-2 white--text" @click="print">
        Imprimer
        <v-icon right dark>
          mdi-printer
        </v-icon>
      </v-btn>
      <v-btn color="danger" class="ma-2 white--text" @click="exportToPDF">
        pdf
        <v-icon right dark>
          mdi-file-pdf-box
        </v-icon>
      </v-btn>

      <template>
        <v-card id="printMe">
          <v-card-title class="text-h6" style="font-weight: bold;">
            Firaketana an-tsoratra ny fanomezana fitaovana na masomboly
          </v-card-title>
          <v-card-text class="mb-0">
            <v-simple-table class="table table-bordered">
              <tbody>
                <tr>
                  <td
                    colspan="3"
                    class="text-h5"
                    style="width: 100%; font-weight: bold;"
                  >
                    Mombamomba ny fikambanana
                  </td>
                </tr>
                <tr>
                  <td>Faritra : {{ this.detailsGroupe.ll_region }}</td>
                  <td>Karazan'ny Fikambanana: GEC</td>
                  <td style="width: 450px;">Coordonnées GPS</td>
                </tr>
                <tr>
                  <td>
                    Distrika:
                    {{ this.detailsGroupe.ll_district }}
                  </td>
                  <td>
                    Anaran'ny Fikambanana:
                    <span style="font-weight: bold;">{{
                      this.detailsGroupe.nom_groupe
                    }}</span>
                  </td>
                  <td>Latitude:{{ detailsGroupe.latitude }}</td>
                </tr>
                <tr>
                  <td>Kominina: {{ this.detailsGroupe.ll_commune }}</td>
                  <td>Daty Niorenana: {{ detailsGroupe.date_constitution }}</td>
                  <td>Longitude: {{ detailsGroupe.longitude }}</td>
                </tr>
                <tr>
                  <td>
                    Fokontany:
                    {{ this.detailsGroupe.ll_fokontany }}
                  </td>
                  <td>
                    Mpiandraikitra:
                    {{ this.detailsGroupe.nom_responsable }}
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>Tanana: {{ detailsGroupe.village }}</td>
                  <td>Anaran'ny président:{{ detailsGroupe.president }}</td>
                  <td></td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
          <v-card-text class="mt-0">
            <div class="text-h6 h6" style="font-weight: bold;">
              MOMBAMOMBA NY MPIKAMBANA SY NY FITAOVANA NA MASOMBOLY NOZARAINA
            </div>
            <div class="text-h6 h6" style="font-weight: bold;">
              Fitaovana na masomboly nozaraina:
            </div>

            <div class="text-h6">
              *Ataovy anaty ( ) ny mari-drefy, ohatra: (kg), (sachet), (taho),
              (isa), …
            </div>
            <div class="text-h6 mb-4" style="font-weight: bold;">
              Daty nanaovana ny fizaràna:
            </div>
            <v-data-table
              :headers="headers"
              hide-default-footer
              :items="this.$route.params.membres"
              :items-per-page="100"
              class="elevation-1 table table-bordered"
            >
              <template v-slot:item.sexe="{ item }">
                {{ getSexe(item.sexe) }}
              </template>
              <template v-slot:item.isa="{ item }">
                <div v-html="isa()"></div>
              </template>
              <template v-slot:item.sonia="{ item }">
                <div v-html="sonia()"></div>
              </template>
              <template v-slot:item.place="{ item }">
                {{ _.indexOf($route.params.membres, item) + 1 }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
//import Vue from 'vue';
import html2pdf from "html2pdf.js";
import VueHtmlToPaper from "vue-html-to-paper";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      output: null,

      headers: [
        {
          text: "#",
          align: "start",
          sortable: false,
          value: "place",
        },
        {
          text: "Anarana sy fanampiny",
          align: "start",
          sortable: false,
          value: "nom",
        },
        { text: "Lahy / Vavy", value: "sexe", sortable: false },
        {
          text: "Taona nahaterahana",
          value: "annee_naissance",
          sortable: false,
        },

        {
          text: "Isan'ny fitaovana  " + "\u000A" + " na masomboly voaray",
          value: "isa",
          sortable: false,
        },

        { text: "Sonia", value: "sonia", sortable: false },
      ],
    };
  },
  created() {
    if (!this.detailsGroupe) {
      this.$router.push({ name: "animateur" });
    } else {
      console.log("idGroupe :", this.$route.params.groupes_code_groupe);
    }
  },

  computed: {
    ...mapState({
      detailsGroupe: (state) => state.Groupes.itemById,
      user: (state) => state.Auth.user,
    }),
  },
  methods: {
    ...mapActions({
      // SetItemById: "Groupes/SetItemById",
    }),
    detailsUser(anim) {
      if (this.user.role != "superviseur") {
        this.$router.push({
          name: "Users-id",
          params: { item: anim },
        });
      } else {
        this.$router.go(-1);
      }
    },
    getSexe(sexe) {
      if (sexe == "1") {
        return "Lahy";
      } else {
        return "Vavy";
      }
    },
    sonia() {
      return "<div style='width:300px; '></div>";
    },
    isa() {
      return "<div style='width:100px'></div>";
    },
    retrunIndex(index) {
      return index;
    },
    print() {
      // Pass the element id here
      this.$htmlToPaper("printMe");
    },
    exportToPDF() {
      let self = this;
      console.log(self.detailsGroupe.nom_groupe);
      html2pdf(document.getElementById("printMe"), {
        margin: 0,
        filename: self.detailsGroupe.nom_groupe + ".pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 3 },
        pagebreak: { mode: "legacy" },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      });
    },
  },
};
</script>

<style>
table th + th {
  border-left: 1px solid #dddddd;
}
table td + td {
  border-left: 1px solid #dddddd;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  vertical-align: middle !important;
  padding: 0 10px !important;
}
table > tbody > tr > td {
  vertical-align: middle !important;
  padding: 0 10px !important;
}
.v-data-table__wrapper {
  border: none !important;
}
</style>
